module.exports = __webpack_public_path__ + "assets/img/matt.ff24cf6f.jpg";